<template>
    <svg width="337" height="185" viewBox="0 0 337 185" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="337" height="185" rx="20" :fill="primaryColor"/>
        <g filter="url(#filter0_b_2742_163467)">
        <rect width="337" height="185" rx="20" fill="white" fill-opacity="0.03"/>
        </g>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M337 125.293V165C337 176.046 328.046 185 317 185H20C8.9543 185 0 176.046 0 165V58.8967C199.366 53.5649 294.154 85.912 337 125.293Z" fill="white" fill-opacity="0.06"/>
        <defs>
        <filter id="filter0_b_2742_163467" x="-80" y="-80" width="497" height="345" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="40"/>
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2742_163467"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2742_163467" result="shape"/>
        </filter>
        </defs>
    </svg>

</template>

<script>
    export default {
        props: {
            primaryColor: {
                type: String,
                required: true
            },
        }
    }
</script>